<div [hidden]="spinnerState"><router-outlet></router-outlet></div>
<div aria-live="polite" toastContainer></div>
<app-utility-spinner-loader [spinnerState]="spinnerState"></app-utility-spinner-loader>
